// extracted by mini-css-extract-plugin
export default {"SectionHeader":"SectionHeading_SectionHeader__BIDUL","heading":"SectionHeading_heading__SD0Iv","subheading":"SectionHeading_subheading__ZTJnM"};